import {createStore} from '../alt';

import SingleObjectResource, {InvalidResponseCode} from '../resources/GenericResource';
import CurrentUserActions from '../actions/CurrentUserActions';
import NotificationSettingActions from '../actions/NotificationSettingActions';


const NotificationSettingSource = {
    updateSettings() {
        return {
            remote(state, data) {
                return new SingleObjectResource(DJ_CONST.API.myNotificationSettings).patch(null, {data});
            },

            success: NotificationSettingActions.updatedSettingsSuccess,
            error: CurrentUserActions.pageFault
        };
    },

    getSettings() {
        return {
            remote(state) {
                return new SingleObjectResource(DJ_CONST.API.myNotificationSettings).fetch();
            },

            success: NotificationSettingActions.getSettingsSuccess,
            error: CurrentUserActions.pageFault
        }
    }
};

class NotificationSettingStore {
    constructor() {
        this.settings = {};
        this.loadedSettings = false;
        this.settingsSaved = false;

        this.exportAsync(NotificationSettingSource);
        this.bindActions(NotificationSettingActions);
    }

    onClearNotificationSettingLoaded() {
        this.setState({loadedSettings: false});
    }

    onUpdatedSettingsSuccess() {
        this.setState({settingsSaved: true});
        setTimeout(x => {this.setState({settingsSaved: false})}, 5000);
    }

    onGetSettingsSuccess(settings) {
        this.setState({settings, loadedSettings: true});
    }
}

export default createStore(NotificationSettingStore, 'NotificationSettingStore', module);



/** WEBPACK FOOTER **
 ** ./app/src/stores/NotificationSettingStore.js
 **/